// Copyright (c) Move Closer 2022.

import Vue from 'vue'
import { AnyObject } from '@movecloser/front-core'

import { IRelatedService, Related } from '../related'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface SearchGroup {
  /**
   * Elements to render.
   */
  elements: AnyObject[]

  /**
   * Group label for
   */
  group: string

  /**
   * Count of all elements.
   */
  totalCount?: number
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface SearchResultConfig {
  /**
   * Component of the particular group.
   */
  component?: SearchResultComponent

  /**
   * Label for group.
   */
  label?: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type SearchResultsConfig = Record<string, SearchResultConfig>

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type SearchResultComponent = typeof _c

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface DisplaySearchResult {
  /**
   * Determines whether component will render/ adjust to mobile.
   */
  element: AnyObject
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type SearchResultItemResolver <I extends Related = Related, O extends AnyObject = AnyObject> =
  (group: string, related: I, relatedService: IRelatedService) => Promise<O>

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
class _c extends Vue implements DisplaySearchResult {
  public element: AnyObject

  constructor (element: AnyObject) {
    super()
    this.element = element
  }
}
